import { EventType, MessageStatus, } from '../graphql/graphql';
import { log } from './logger';
import { Order, ReadonlyArray, ReadonlyRecord } from 'effect';
export function deduplicateChatEventsUsingId(events) {
    const deduplicatedEvents = [];
    for (const event of events) {
        const idx = deduplicatedEvents.findIndex(x => x.id === event.id);
        if (idx === -1) {
            deduplicatedEvents.push(event);
        }
        else {
            if (event.persistedTimestamp > deduplicatedEvents[idx].persistedTimestamp) {
                deduplicatedEvents[idx] = event;
            }
        }
    }
    return deduplicatedEvents;
}
export function deduplicateSupportCaseStatusEvents(events) {
    return events.filter((ev, i) => {
        var _a, _b;
        return i === 0 ||
            ev.type !== EventType.SupportCaseStatus ||
            ((_a = ev.supportCaseStatusEvent) === null || _a === void 0 ? void 0 : _a.status) !==
                ((_b = events[i - 1].supportCaseStatusEvent) === null || _b === void 0 ? void 0 : _b.status);
    });
}
export const getMessageStatusEventsMap = (allEvents) => {
    const statusEvents = allEvents.filter((m) => !!m && m.type === EventType.MessageStatus);
    const sortedEvents = ReadonlyArray.sortWith(statusEvents, ev => +ev.persistedTimestamp, Order.reverse(Order.number));
    const grouped = ReadonlyArray.groupBy(sortedEvents, ev => ev.messageStatusEvent.messageId);
    return ReadonlyRecord.map(grouped, events => events[0]);
};
export const updateChatEvents = (mergedEventsWithoutMessageStatusEvents, messageStatusEventsMap) => mergedEventsWithoutMessageStatusEvents.map(event => {
    if (!(event.id in messageStatusEventsMap) ||
        +messageStatusEventsMap[event.id].persistedTimestamp <
            +event.persistedTimestamp) {
        return event;
    }
    switch (messageStatusEventsMap[event.id].messageStatusEvent.status) {
        case MessageStatus.NotDelivered: {
            return Object.assign(Object.assign({}, event), { failed: true, loading: false });
        }
        case MessageStatus.Read: {
            return Object.assign(Object.assign({}, event), { loading: false, readByCustomer: true });
        }
        default: {
            log.error('Not implemented message status', messageStatusEventsMap[event.id].messageStatusEvent.status);
            return event;
        }
    }
});
